<template>
    <div class="plugin__entry">
        <router-link :to="{path: '/detail/' + id + '/overview'}" class="plugin__entry--top">
            <div v-if="logo" class="entry__image">
                <plugin-logo :size="size" :type="logo.type" :path="logo.path"></plugin-logo>
            </div>
            <div class="entry__title">
                <h3>{{title}}</h3>
            </div>
            <div class="entry__meta">
                <span class="info">
                    <span v-if="type == 'addon'" class="info--technology">{{technologies.value}}</span>
                    <template v-if="type == 'addon'"> • </template>
                    <span v-if="brands" class="info--technology">{{brands.value}}</span>
                </span>
                <p class="description">{{short_description}}</p>
                <div class="rating" v-if="rating && rating.count > 0">
                    <span>
                        <svg v-for="star in parseInt(Math.floor(rating.average))" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path  fill="#575C61" d="m55,237 74-228 74,228L9,96h240"/></svg>
                        <svg v-for="star in parseInt(5 - Math.floor(rating.average))" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path fill="rgb(87,92,97, 0.25)" d="m55,237 74-228 74,228L9,96h240"/></svg>
                    </span>
                    <span class="rating__counter">
                        {{rating.count}}
                    </span>
                </div>
            </div>
        </router-link>
        <div class="entry__meta">
            <div class="creator" v-if="creator">
                {{$t('by')}} <span class="creator--link" :id="creator.key"><router-link :to="{path: '/vendor/' + creator.key + '-' + creator.id}">{{creator.value}}</router-link></span>
                <svg v-if="creator.company_type == 1" width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="icons-/-filled-/-badge-loxone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350"></path>
                    </g>
                </svg>
                <svg v-if="creator.company_type == 2" width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="icons-/-filled-/-badge-vendor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#575C61"></path>
                    </g>
                </svg>
            </div>
        </div>
        <div v-if="certified" class="certified">
            <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Loxone-Ready" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Loxone-Ready---Startseite" transform="translate(-1168.000000, -1177.000000)" fill="#69C350">
                        <g id="Kachel" transform="translate(936.000000, 1153.000000)">
                            <g id="Loxone-Ready" transform="translate(232.000000, 24.000000)">
                                <path d="M17.3276015,0 L0,0 L0,26.679417 L17.3276015,0 Z M31.9997179,5.98447313 L31.9997179,32 L15.1067205,32 L31.9990127,32 L31.9990127,5.9855667 L31.9997179,5.98447313 Z" id="Shape"></path>
                                <polygon id="Path" fill-opacity="0.4" fill-rule="nonzero" points="15.1070496 31.9999525 32 5.98447313 32 31.9999525"></polygon>
                                <polygon id="Path" fill-opacity="0.7" points="17.3276015 0 0 26.679417 0 32 15.1067205 32 31.9997179 5.98447313 31.9997179 0"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div v-if="highlight" class="highlight" :class="{'ready': certified}">
            <svg width="32px" height="32px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="icons-/-filled-/-Heart" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path d="M12,6.04168892 C9.33165018,-0.396099541 1,1.2374529 1,8.24936117 C1,9.44662657 1.42522258,10.7488894 2.21745959,12.1427661 C3.16055591,13.8020676 4.5996091,15.5528036 6.4023296,17.3429285 C7.56530417,18.4977774 8.80980511,19.5999935 10.0542382,20.6130947 C10.4898251,20.9677088 10.8944894,21.2860107 11.2579947,21.5633617 C11.4769961,21.7304577 11.6342722,21.8472421 11.7195736,21.9090561 C11.8869068,22.0303146 12.1130932,22.0303146 12.2804264,21.9090561 C12.3657278,21.8472421 12.5230039,21.7304577 12.7420053,21.5633617 C13.1055106,21.2860107 13.5101749,20.9677088 13.9457618,20.6130947 C15.1901949,19.5999935 16.4346958,18.4977774 17.5976704,17.3429285 C19.4003909,15.5528036 20.8394441,13.8020676 21.7825404,12.1427661 C22.5747774,10.7488894 23,9.44662657 23,8.24936117 C23,1.2374529 14.6683498,-0.396099541 12,6.04168892 Z" id="Path" fill="#E73246"></path>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import PluginLogo from './PluginLogo.vue'
export default {
  components: { PluginLogo },
    props: {
        title: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        logo: {
            type: Object,
            required: true,
        },
        size: {
            type: Number,
            required: false,
        },
        short_description: {
            type: String,
            required: true,
        },
        creator: {
            type: Object,
            required: true,
        },
        technologies: {
            type: Object,
            required: true,
        },
        brands: {
            type: Object,
            required: true,
        },
        rating: {
            type: Object,
            required: true
        },
        highlight: {
            type: Boolean,
            required: false,
        },
        certified: {
            type: Boolean,
            required: false,
        },
        type: {
            type: String,
            required: true,
        }
    },
    methods: {
        openDetailPage() {
            this.$router.push({ name: 'Details', params: { id: this.title }})
        }
    },
}
</script>

<style scoped>
    .plugin__entry{
        padding: 25px;
        background-color: #FFFFFF;
        border: 1px solid #DEDEDE;
        box-sizing: border-box;
        position: relative;
        transition: box-shadow .25s;
    }
    .plugin__entry:hover{
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 25%);
        transition: box-shadow .25s;
        cursor: pointer;
    }
    .entry__image{
        padding-bottom: 25px;
    }
    .entry__title h3{
        font-weight: normal;
        margin: 0;
        font-size: 23px;
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-bottom: 10px;
        text-decoration: none;
        color: #000000;
    }
    .plugin__entry--top{
        text-decoration: none;
    }
    .entry__meta{
        text-decoration: none;
        color: #575C61;
    }
    .entry__meta .info{
        font-size: 14px;
        line-height: 20px;
        color: #575C61;
    }

    .entry__meta .description{
        padding-top: 20px;
        padding-bottom: 15px;
        margin: 0;
        font-size: 16px;
        line-height: 23px;
        color: #575C61;
    }

    .rating{
        padding-bottom: 15px;
    }

    .creator{
        font-size: 14px;
        line-height: 20px;
        color: #000A12;
        vertical-align: top;
    }
    .creator .creator--link a{
        color: #E73246;
        text-decoration: none;
    }
    .creator svg{
        padding-left: 3px;
        padding-top: 2px;
        vertical-align: top;
    }
    .rating__counter{
        font-size: 14px;
        line-height: 20px;
        padding-left: 5px;
        display: inline-block;
        vertical-align: top;
        color: #575C61;
    }
    .entry__image img{
        width: 100%;
        height: auto;
        max-width: 128px;
        max-height: 128px;
    }
    .highlight{
        position: absolute;
        top: 25px;
        right: 25px;
    }

    .certified{
        position: absolute;
        top: 25px;
        right: 25px;
    }

    .highlight.ready{
        position: absolute;
        top: 25px;
        right: 67px;
    }
</style>